import { forwardRef, ReactNode, HTMLAttributes } from "react";

interface IModalTitleProps extends HTMLAttributes<HTMLHeadingElement> {
  className?: string;
  children: ReactNode;
}

// Forwarding ref to ensure this component can hold a ref
const ModalTitle = forwardRef<HTMLHeadingElement, IModalTitleProps>(
  ({ className, children, ...rest }, ref) => {
    return (
      <h1 ref={ref} className={`modal-title ${className}`} {...rest}>
        {children}
      </h1>
    );
  },
);

export { ModalTitle };
